module.exports = __webpack_public_path__ + "static/img/bg-fr.b4616c65.png";